import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-bitacora-historico',
  templateUrl: './bitacora-historico.component.html',
  styleUrls: ['./bitacora-historico.component.css']
})
export class BitacoraHistoricoComponent implements OnInit {

  @Input() bitacora: any[]; 
  
  constructor() { }

  ngOnInit(): void {
  }

}
